// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_AG9","cls2":"LettersModal-cls2_mDE LettersModal-cls1_AG9"};